<template>
  <div>
    <div class="row" style="margin: 1rem 0 !important;">
      <div
        class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 no-padding"
        style="text-align: left; padding-left: 0.5rem !important; margin-top: 0.5rem"
      >
        <span class="num-wrapper">{{ indexNum + 1 }}</span>
      </div>
      <div class="col-5 col-sm-5 col-md-5 col-lg-3 col-xl-3 exp-details">
        <div class="designation">{{ work.designation }}</div>
        <div class="company">
          <div>{{ work.company_name }}</div>
          <div>
            {{ calculateDuration() + calculateDurationInYears() }}
          </div>
          <div v-if="work.location_name">
            {{ work.location_name }}
          </div>
        </div>
      </div>
      <div
        class="col-6 col-sm-6 col-md-6 col-lg-8 col-xl-8"
        style="text-align: left"
      >
        <div v-if="work.experience_description" class="description">
          <span>{{ work.experience_description }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: { exp: Object, end: Boolean, ind: Number },
  data: function() {
    return {
      work: {},
      indexNum: parseInt(this.ind),
      editCurrent: false,
      popupProps: {
        open: false,
        title: "Please close the currently opened box first"
      },
      check: 0,
      overflowed: false,
      truncateView: true
    };
  },
  methods: {
    calculateEllipsesText: function() {
      const self = this;
      const maxLength = 60;
      if (self.work.experience_description) {
        let description = self.work.experience_description;
        let length = description.length;
        if (length <= maxLength) {
          this.overflowed = false;
          return description;
        } else {
          let line1 = description.substring(0, 60) + "\n";
          let line2, line3;
          if (length / maxLength < 3) {
            this.overflowed = false;
            if (length / maxLength < 2) {
              line2 = description.substring(60, length) + "\n";
              line1 += line2;
            } else {
              line2 = description.substring(60, 120) + "\n";
              line3 = description.substring(120, length) + "\n";
              line1 = line1 + line2 + line3;
            }
          } else {
            this.overflowed = true;
            line2 = description.substring(60, 120) + "\n";
            line3 = description.substring(120, 160) + "\n";
            line1 = line1 + line2 + line3;
          }
          return line1;
        }
      } else {
        return;
      }
    },
    onMore: function() {
      this.truncateView = false;
    },
    onLess: function() {
      this.truncateView = true;
    },
    calculateDuration: function() {
      const self = this;
      let start = self.work.start_year;
      let end;
      if (self.work.is_working) {
        end = "Present";
      } else {
        end = self.work.end_year;
      }
      return start + " - " + end;
    },
    calculateDurationInYears: function() {
      const self = this;
      let msg = "";
      let start = self.work.start_year;
      let end;
      if (self.work.is_working) {
        end = new Date().getFullYear();
      } else {
        end = self.work.end_year;
      }
      let total = end - start;
      if (total === 0) {
        msg = " (Less than a year)";
      } else if (total > 0) {
        let y = " years)";
        if (total === 1) {
          y = " year)";
        }
        msg = " (Over " + total + y;
      } else {
        msg = "Invalid";
      }
      return msg;
    },
    onDeleteExperience: function() {
      let id = this.work.attrib_id;
      this.$emit("delete-exp", id);
    },
    onSaveCurrentExperience: function(newWork) {
      this.editCurrent = false;
      this.$emit("save-exp", newWork);
    },
    onCancelCurrentExperience: function() {
      this.editCurrent = false;
      this.$emit("cancel-exp", "child");
    }
  },
  mounted() {
    this.work = this.exp;
  }
};
</script>

<style>
.exp-details {
  padding: 0;
  text-align: left;
}
.num-wrapper {
  color: #3d4249;
  border: 0.1rem solid #3d4249;
  border-radius: 50%;
  padding: 0.1rem 0.6rem;
}
.designation {
  line-height: 1.5;
  text-align: left;
  color: #000000;
  font-weight: bold;
  font-size: 1.6rem;
}
.company {
  font-size: 1.6rem;
}
.exp-details-years {
  font-size: 1.2rem;
  line-height: 1.33;
  text-align: left;
  color: rgba(5, 5, 5, 0.74);
}
.location {
  color: #808080;
  font-weight: 400;
}
.description {
  font-size: 1.4rem;
}
.more-less {
  color: #207688;
  padding-left: 0.5rem;
}
</style>
